import { Text } from "@mantine/core";
import { SystemEmailMode } from "../../../services/admin/systemEmails.service";

interface Props {
  emailLabel: string;
  mode: SystemEmailMode | null;
}
const COPY = {
  on: "New messages of this type will send normally.",
  review:
    "New messages will wait in Pending Emails until an authorised user releases them.",
  off: "New messages will be blocked and can only be sent by releasing them individually.",
};

export function SystemEmailModeDescription({ emailLabel, mode }: Props) {
  return (
    <Text>
      <Text component="span" fw={600}>
        {emailLabel}:
      </Text>{" "}
      {mode ? COPY[mode] : ""}
    </Text>
  );
}
